// extracted by mini-css-extract-plugin
export default {"root":"CustomCheckbox_root__sL2+r","input":"CustomCheckbox_input__McztU","label":"CustomCheckbox_label__Xsgfs","disabled":"CustomCheckbox_disabled__ryzmj"};